module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/view/home/home.component.html
// module id = ./src/app/view/home/home.component.html
// module chunks = main